import {
  createNewProgram,
  createNewProgramInstance,
  createNewProject,
  deleteProgram,
  deleteProgramInstance,
  deleteProjectWithReferenceCheck,
  EDIT_PROGRAM_DIALOG_OPEN,
  EDIT_PROGRAM_INSTANCE_DIALOG_OPEN,
  EDIT_PROJECT_DIALOG_OPEN,
  EDITED_PROGRAM,
  EDITED_PROGRAM_INSTANCE,
  EDITED_PROJECT,
  editProgram,
  editProgramInstance,
  editProject,
  loadMasterData,
  programChange,
  programDialogOpenChange,
  programInstanceChange,
  programInstanceDialogOpenChange,
  projectChange,
  projectDialogOpenChange,
  saveProgram,
  saveProgramInstance,
  saveProject,
  SELECTED_FUNDING_AREA_ID,
  SELECTED_PROGRAM_ID,
  SELECTED_PROGRAM_INSTANCE_ID,
  selectFundingArea,
  selectProgram,
  selectProgramInstance
} from "../../../ducks/masterData";
import { loadUniversities, UNIVERSITY_LIST } from "../../../ducks/university";

import { useLayoutEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { COUNTRY_STORE, FUNDING_AREA_STORE, LECTORATE_TYPE_STORE, LOGIN_STORE, MASTER_DATA_STORE, REGION_STORE, UNIVERSITY_STORE } from "../../../common/constant";
import { COUNTRY_OPTIONS, loadCountries } from "../../../ducks/country";
import { FUNDING_AREA_LIST } from "../../../ducks/fundingArea";
import { LECTORATE_TYPE_OPTIONS, loadLectorateTypes } from "../../../ducks/lectorateType";
import { OPEN } from "../../../ducks/loadingSpinner";
import { IS_LOGGED_IN_KEY } from "../../../ducks/login";
import { clearMessages } from "../../../ducks/message";
import { loadRegions, REGION_OPTIONS } from "../../../ducks/regions";
import MasterDataManagement from "./MasterDataManagement";

const mapStateToProps = (state) => {
  const fundingAreaList = state[FUNDING_AREA_STORE][FUNDING_AREA_LIST].masterDataManagament || [];

  const selectedFundingAreaId = state[MASTER_DATA_STORE][SELECTED_FUNDING_AREA_ID];
  const selectedProgramId = state[MASTER_DATA_STORE][SELECTED_PROGRAM_ID];
  const selectedFProgramInstanceId = state[MASTER_DATA_STORE][SELECTED_PROGRAM_INSTANCE_ID];

  const selectedFundingArea = selectedFundingAreaId
    ? fundingAreaList.find((fa) => fa.id === selectedFundingAreaId)
    : undefined;
  const selectedProgram =
    selectedProgramId && selectedFundingArea
      ? selectedFundingArea.programs.find((program) => program.id === selectedProgramId)
      : undefined;
  const selectedProgramInstance =
    selectedFProgramInstanceId && selectedProgram
      ? selectedProgram.programInstances.find((programInst) => programInst.id === selectedFProgramInstanceId)
      : undefined;

  return {
    [FUNDING_AREA_LIST]: fundingAreaList,
    selectedFundingArea: selectedFundingArea,
    selectedProgram: selectedProgram,
    selectedProgramInstance: selectedProgramInstance,
    loading: state.loading[OPEN],

    universityList: state[UNIVERSITY_STORE][UNIVERSITY_LIST],
    countryOptions: state[COUNTRY_STORE][COUNTRY_OPTIONS],
    regionsOptions: state[REGION_STORE][REGION_OPTIONS],
    lectorateTypeOptions: state[LECTORATE_TYPE_STORE][LECTORATE_TYPE_OPTIONS],

    editedProgram: state[MASTER_DATA_STORE][EDITED_PROGRAM],
    editedProgramInstance: state[MASTER_DATA_STORE][EDITED_PROGRAM_INSTANCE],
    editedProject: state[MASTER_DATA_STORE][EDITED_PROJECT],

    editProgramDialogOpen: state[MASTER_DATA_STORE][EDIT_PROGRAM_DIALOG_OPEN],
    editProgramInstanceDialogOpen: state[MASTER_DATA_STORE][EDIT_PROGRAM_INSTANCE_DIALOG_OPEN],
    editProjectDialogOpen: state[MASTER_DATA_STORE][EDIT_PROJECT_DIALOG_OPEN],
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      selectFundingArea,
      selectProgram,
      selectProgramInstance,

      loadMasterData,
      loadUniversities,

      createNewProgram,
      createNewProgramInstance,
      createNewProject,

      editProgram,
      editProgramInstance,
      editProject,

      deleteProjectWithReferenceCheck,
      deleteProgramInstance,
      deleteProgram,

      saveProgram,
      saveProgramInstance,
      saveProject,

      programChange,
      programInstanceChange,
      projectChange,

      programDialogOpenChange,
      programInstanceDialogOpenChange,
      projectDialogOpenChange,

      clearMessages
    },
    dispatch
  );
};

const MasterDataManagementContainer = connect(mapStateToProps, mapDispatchToProps)(MasterDataManagement);

// TODO: #1 this HOC-Below is an example of how react-router v6 Route-"loader" should work.
// TODO: #2 every single privileged request (i.e. must be logged in) must not be executed if the user is not logged in!

const MasterDataManagementLoader = () => {
  const dispatch = useDispatch();

  const { paramFundingArea, paramProgram, paramProgramInstance } = useParams();

  const isLoggedIn = useSelector((state) => state[LOGIN_STORE][IS_LOGGED_IN_KEY]);

  useLayoutEffect(() => {
    if (isLoggedIn) {
      dispatch(clearMessages());
      dispatch(loadMasterData());
      dispatch(loadUniversities());
      dispatch(loadCountries());
      dispatch(loadRegions());
      dispatch(loadLectorateTypes());
    }

    return () => {
      dispatch(clearMessages());
    };
  }, [isLoggedIn, dispatch]);

  useLayoutEffect(() => {
    dispatch(selectFundingArea(paramFundingArea));
  }, [dispatch, paramFundingArea]);

  useLayoutEffect(() => {
    dispatch(selectProgram(paramProgram));
  }, [dispatch, paramProgram]);

  useLayoutEffect(() => {
    dispatch(selectProgramInstance(paramProgramInstance));
  }, [dispatch, paramProgramInstance]);

  return <MasterDataManagementContainer />;
};

export default MasterDataManagementLoader;
